/**
 * Asynchronously loads the component for StudentCommunity
 */

import { lazyLoad } from "utils/loadable";

export const StudentCommunity = lazyLoad(
  () => import("./index"),
  (module) => module.StudentCommunity
);
